module.exports = __webpack_public_path__ + "static/media/8_l_kreslo_8.33_75.74.98eb25ae.png";